import { cn } from "@/lib/utils";

// Use type alias instead of empty interface extension
type SkeletonProps = React.HTMLAttributes<HTMLDivElement>

export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn("rounded-md bg-muted", className)}
      {...props}
    />
  );
}
